import './styles/notification-area-container.scss';
import React, {PropTypes} from 'react';

const NotificationAreaContainer = props =>
    <div className='notification-area-container'>
        {props.children}
    </div>;

NotificationAreaContainer.displayName = 'NotificationAreaContainer';

NotificationAreaContainer.propTypes = {
    children: PropTypes.any.isRequired
};

export default NotificationAreaContainer;



// WEBPACK FOOTER //
// ./src/shared/components/alert-bar/notification-area-container.js